import React, { useEffect, useState } from "react";
import { Alert, Card, Form } from "react-bootstrap";
import { adminGet, adminMutation, errorMessage } from "./api";

export default function BillingMode({ canManage }) {
  const [mode, setMode] = useState("production");
  const [busy, setBusy] = useState(true);
  const [error, setError] = useState("");
  useEffect(() => {
    let active = true;
    adminGet("/billing/mode").then(data => { if (active) setMode(data.mode); })
      .catch(failure => { if (active) setError(errorMessage(failure)); })
      .finally(() => { if (active) setBusy(false); });
    return () => { active = false; };
  }, []);
  async function change(event) {
    const next = event.target.checked ? "test" : "production";
    setBusy(true); setError("");
    try { const data = await adminMutation("patch", "/billing/mode", { mode: next }); setMode(data.mode); }
    catch (failure) { setError(errorMessage(failure)); }
    finally { setBusy(false); }
  }
  return <Card className="mb-3"><Card.Header>Stripe billing mode</Card.Header><Card.Body>
    {error && <Alert variant="danger">{error}</Alert>}
    <Form.Check type="switch" id="stripe-billing-mode" label={mode === "test" ? "Test Mode" : "Production Mode"}
      checked={mode === "test"} disabled={busy || !canManage} onChange={change} />
    <p className="text-muted mb-0 mt-2">{mode === "test" ? "All billing and charging activity uses Stripe test keys." : "All billing and charging activity uses Stripe production keys."}</p>
  </Card.Body></Card>;
}
